import React from "react";
import {CKEditor} from "ckeditor4-react";

export default ({value, config, ...props}) => {
    config = Object.assign({}, config, {
        language: 'ru',
        // отключение проверки версии, при обновлении "ckeditor4-react" требует "react@18.0.0"
        versionCheck: false,
        extraPlugins: 'justify,font,colorbutton',
        removeButtons: 'Styles,Format,Outdent,Indent,BGColor',
        toolbarGroups: [
            { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
            { name: 'tools', groups: [ 'tools' ] },
            { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
            { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
            { name: 'forms', groups: [ 'forms' ] },
            { name: 'links', groups: [ 'links' ] },
            { name: 'insert', groups: [ 'insert' ] },
            { name: 'about', groups: [ 'about' ] },
            '/',
            { name: 'styles', groups: [ 'styles' ] },
            { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
            { name: 'colors', groups: [ 'colors' ] },
            { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
            { name: 'others', groups: [ 'others' ] },
        ],
    });

    return (
        <CKEditor
            config={config}
            initData={value}
            {...props}
        />
    );
};
